
const user_management_zh = {
  account:'账号',
  reg_time:'注册时间',
  start_time:'开始时间',
  end_time:'结束时间',

  empty_account:'请输入账号',
  empty_name:'请输入姓名',
  empty_password:'请输入密码',
  pwd_condition:'长度在 8 到 14 个字符',
  pwd_again:'请再次输入密码',
  pwd_inconsistent:'两次输入密码不一致',
  empty_email:'请输入邮箱地址',
  email_error:'请输入正确的邮箱地址',
  empty_dept:'请选择部门',
  roles_error:'请选择需要分配的角色',

  edit_user_info:'编辑用户信息',
  add_user_info:'新增用户信息',
  reset_pwd:'是否重置密码？'
}

export default user_management_zh



// WEBPACK FOOTER //
// ./src/common/lang/user_management/user_management_zh.js